<template>
  <div class="prahndsttls_stats">
    <slot name="title">
      <div class="prahndsttls_stats_title prahndsttls_stats_item">
        <h1 class="text-large weight_600">
          {{ $t(`practice_totals.title`) }}
        </h1>
      </div>
    </slot>
    <slot></slot>
    <PracticeStatsMainInfo
      class="mr-auto"
      :items="totals.topBoxes"
      style="--size-title: 1rem; --size-value: 2rem; --display: flex; --grid-gap: 2rem"
    />
    <PracticeStatsScoreTrendChart
      v-if="hasGtoScoreTrendChart"
      :items="totals.gto_score_trend"
      :loading="loading"
    />
    <PracticeStatMovesChart
      style="
        --clr-back: transparent;
        min-height: 8rem;
        --chart-clr-back: var(--stats-chart-clr-back);
      "
      :items="totals.moves"
      :displayAs="mobile ? 'table' : 'column'"
    />
    <PracticeStatsSecondaryInfo
      v-if="hasEvStats"
      :items="totals.rows"
    />
    <slot name="stats_after"></slot>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import PracticeStatsMainInfo from '@/components/PracticeHandsTotals/PracticeStatsMainInfo'
import PracticeStatsSecondaryInfo from '@/components/PracticeHandsTotals/PracticeStatsSecondaryInfo'
import PracticeStatMovesChart from '@/components/PracticeHandsTotals/PracticeStatMovesChart'
import PracticeStatsScoreTrendChart from '@/components/PracticeHandsTotals/PracticeStatsScoreTrendChart'

export default {
  name: 'PracticeHandsTotalsStats',
  components: {
    PracticeStatsMainInfo,
    PracticeStatsSecondaryInfo,
    PracticeStatMovesChart,
    PracticeStatsScoreTrendChart,
  },
  mixins: [format_mix, float_mix],
  props: {
    totals: Object,
    loading: Boolean,
    hasEvStats: { type: Boolean, default: true },
    hasSubtitle: { type: Boolean, default: true },
    hasGtoScoreTrendChart: { type: Boolean, default: true },
  },
  computed: {
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>

<style lang="scss" scoped>
.prahndsttls {
  &_stats {
    --clr-back: var(--clr-black-1);
    --clr-title: var(--clr-white-0);
    --clr-text: var(--clr-grey-2);
    --stats-chart-clr-back: var(--clr-black-3);
    --gap: 2rem;
    --padding: 1.5rem;
    padding: var(--padding);
    grid-gap: var(--gap);
    border-radius: 4px;
    position: relative;
    background: var(--clr-back);
    display: flex;
    flex-direction: column;
    margin-bottom: auto;
    flex: 1;
    &_content {
      display: flex;
      grid-gap: 1.5rem;
      flex-wrap: wrap;
    }
    &_moves {
      flex: 1;
      display: flex;
      grid-gap: 0.5rem;
      min-height: 7rem;
      min-width: clamp(12rem, 24rem, calc(100vw - 6rem));
      &_table {
        display: table;
      }
      &_move {
        &_label {
          display: flex;
          align-items: center;
          justify-content: center;
          align-items: center;
          font-size: 0.875rem;
          font-weight: 500;
          white-space: nowrap;
        }
        &_icon {
          font-size: 1rem;
          margin: 0 0.5rem 0 0;
          line-height: 1;
        }
        &_chart {
          flex: 1;
        }
      }
    }
  }
}

@media (max-width: 450px) {
  .prahndsttls {
    &_stats {
      &_value-boxes {
        grid-template-columns: 1fr 1fr;
      }
    }
  }
}
</style>
